export default __webpack_public_path__ + "static/media/Beauty.9a741c2e.jpg";